import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaForm from 'Components/ComponentLibrary/Organisms/MetaForm';
import DataContainer from 'Components/UI/DataContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';
import Override from './MetaOverrideSet';

const styles = () => ({
  root: {},
});

const EditFacetPlanTemplate = ({
  className,
  classes,
  collection,
}) => {
  const { isPageContentLoading, pageContentLoadingError } = usePageContentContext();

  return (
    <DataContainer
      component={MetaForm}
      componentProps={{
        className: classNames(className, classes.root),
        metaOverrideSet: Override,
        layout: Content,
        collection,
      }}
      loading={isPageContentLoading}
      loadingError={pageContentLoadingError}
    />
  );
};

EditFacetPlanTemplate.defaultProps = {
  className: '',
};

EditFacetPlanTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export default withStyles(styles)(EditFacetPlanTemplate);
